import { render, staticRenderFns } from "./passenger-change-assign-dialog.vue?vue&type=template&id=3c31fc6e&scoped=true"
import script from "./passenger-change-assign-dialog.vue?vue&type=script&lang=js"
export * from "./passenger-change-assign-dialog.vue?vue&type=script&lang=js"
import style0 from "./passenger-change-assign-dialog.vue?vue&type=style&index=0&id=3c31fc6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c31fc6e",
  null
  
)

export default component.exports